import { AudioManager } from '../core/AudioManager';
import { UIManager } from '../core/UIManager';
import { AbstractScene } from './AbstractScene';
export class UIScene extends AbstractScene {
    constructor() {
        super('ui');
    }
    init() {
        this.zoomScale = 1;
        super.init();
    }
    createUIElements() {
        this.uiManager = new UIManager(this);
        this.audioManager = new AudioManager(this);
        this.audioManager.initUIAudio();
        this.input.on(Phaser.Input.Events.POINTER_DOWN, () => {
            if (this.game.scale.fullscreen.available && !this.game.scale.isFullscreen) {
                // eslint-disable-next-line no-undef
                if (process.env.NODE_ENV !== 'development') {
                    // this.game.scale.startFullscreen();
                }
            }
        });
        // Debug performance
        // this.renderer.captureFrame(false, false);
    }
    create() {
        this.createUIElements();
        this.resizeAndRepositionElements();
    }
    resizeAndRepositionElements() {
        if (this.uiManager) {
            this.uiManager.resizeAndRepositionElements();
        }
    }
}
